import { useState } from 'react';
import { DEFAULT_THIS_YEAR_PERIOD } from '@/helpers/date';
import { ReportDownloadModal } from '@/modals/ReportDownloadModal';
import { ReportReferenceModal } from '@/modals/ReportReferenceModal';
import { Filters } from './components/Filters';
import { DataView } from './components/DataView';
import s from './index.module.scss';

const PortfolioMovementsPage = () => {
  const [params, setParams] = useState({
    page: 1,
    range: DEFAULT_THIS_YEAR_PERIOD,
    grouping: true,
  });

  return (
    <div className={s.page}>
      <Filters params={params} setParams={setParams} />
      <DataView params={params} setParams={setParams} />
      <ReportDownloadModal type="portfolio_movements" params={params} />
      <ReportReferenceModal />
    </div>
  );
};

export default PortfolioMovementsPage;
